import type { RouteRecordRaw } from 'vue-router';
import { useAccessControlStore } from '@peanuds/app-shell';
import { useUserAccountsStore } from '@peanuds/shared-state';
import { SEND_MONEY_ROUTE_NAME } from '../internal/send-money.constants';
import { useBatchPaymentsEnabled } from './composables/useBatchPaymentsEnabled';

export const BATCH_PAYMENTS_ROUTE_NAME = 'batch-payments';
export const BATCH_PAYMENT_DRAFT_REVIEW_ROUTE_NAME = 'batch-payment-draft-review';
export const BATCH_PAYMENT_DETAILS_ROUTE_NAME = 'batch-payment-details';

export const batchPaymentsAccessGuard = async () => {
  const enabled = useBatchPaymentsEnabled();
  const access = useAccessControlStore();
  const denied = { name: SEND_MONEY_ROUTE_NAME };
  if (!enabled.value) return denied;
  await access.ensureAccessResolved();
  if (!access.isAccessResolved) return true;
  if (!access.isOnboarded) return denied;
  const accounts = useUserAccountsStore();
  await accounts.ensureAccountsLoaded();
  // Unavailable readiness belongs to the page's retry state, not an access denial.
  if (!accounts.hasLoadedAccounts || accounts.error) return true;
  return accounts.accounts.length > 0 ? true : denied;
};

export const batchPaymentsRoutes: RouteRecordRaw[] = [
  {
    path: 'send-money/batch-payments/:batchId',
    name: BATCH_PAYMENT_DETAILS_ROUTE_NAME,
    component: () => import('./BatchPaymentDetailsPage.vue'),
    props: true,
    beforeEnter: batchPaymentsAccessGuard,
    meta: { title: 'Batch Payment Details' },
  },
  {
    path: 'send-money/batch-payments/:draftId/review',
    name: BATCH_PAYMENT_DRAFT_REVIEW_ROUTE_NAME,
    component: () => import('./BatchPaymentReviewPage.vue'),
    props: (route) => ({
      draftId: route.params.draftId,
      excludedRows: Number(route.query.excludedRows) || 0,
    }),
    beforeEnter: batchPaymentsAccessGuard,
    meta: { title: 'Review Batch Payment' },
  },
  {
    path: 'send-money/batch-payments',
    name: BATCH_PAYMENTS_ROUTE_NAME,
    component: () => import('./BatchPaymentsPage.vue'),
    beforeEnter: batchPaymentsAccessGuard,
    meta: { title: 'Batch Payments' },
  },
];
